module.exports = __webpack_public_path__ + "static/media/bg-banner1.c31dd0f7.jpeg";